import { createSlice } from "@reduxjs/toolkit";

const OthersSlice = createSlice({
  name: "others",
  initialState: {
    IsActiveTopNotifyAlert: true,
    NotificationText: "",
    SelectedPage: "Products",
    CountryList: [],
    StateList: [],
    ShipmentMode: [],
    PalletInfo: null,
    PackingInfo: [],
    RegionsList: []

  },
  reducers: {
    setNotifyAlertOnChange: (state, action) => {
      state.IsActiveTopNotifyAlert = action.payload;
    },
    setNotifyAlert: (state, action) => {
      state.NotificationText = action.payload;
    },
    setSelectedPage: (state, action) => {
      state.SelectedPage = action.payload;
    },
    setCountryList: (state, action) => {
      state.CountryList = action.payload;
    },
    setStateList: (state, action) => {
      state.StateList = action.payload;
    },
    setShipmentModeList: (state, action) => {
      state.ShipmentMode = action.payload;
    },
    setPalletInfo: (state, action) => {
      state.PalletInfo = action.payload;
    },
    setPackingInfo: (state, action) => {
      state.PackingInfo = action.payload;
    },
    setRegionList: (state, action) => {
      state.RegionsList = action.payload;
    },
  },
});

export const {
  setNotifyAlertOnChange,
  setNotifyAlert,
  setSelectedPage,
  setCountryList,
  setStateList,
  setShipmentModeList,
  setPalletInfo,
  setPackingInfo,
  setRegionList
} = OthersSlice.actions;

export default OthersSlice.reducer;
